import {HttpServices} from '../Helpers';
import {PHP_V13_URL} from '../api/urls';

const VERSION = `${process.env.REACT_APP_VERSION_API}`;

export const GetAllSetupsJobTitle = async ({
    limit,
    page,
    search,
    user_type,
    status = true,
    use_for = 'dropdown',
    with_than,
    other_than
}) => {
    const queryList = [];
    if (limit || limit === 0) queryList.push(`limit=${limit}`);
    if (page || page === 0) queryList.push(`page=${page}`);
    if (search) queryList.push(`query=${search}`);
    if (user_type || user_type === 0) queryList.push(`user_type=${user_type}`);
    if (status) queryList.push(`status=${status}`);
    if (use_for) queryList.push(`use_for=${use_for}`);

    const result = await HttpServices.get(
        `${PHP_V13_URL}/api/setup/${VERSION}/organizational/job-title?${queryList.join('&')}`,
        {
            params: {with_than, other_than},
        },
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};

export const GetSetupsJobTitleView = async ({uuid}) => {
    const result = await HttpServices.get(
        `${PHP_V13_URL}/api/setup/${VERSION}/organizational/job-title/view`,
        {params: {uuid, use_for: "job_description"}},
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};
